import { writable } from 'svelte/store';
export const ORGANIZATION_STORE = writable({});
export const ORGANIZATION_HASH = writable('initial');
